// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"2ca69f43","453":"2ae4ec24","455":"fdbfcaa1"}[chunkId] + ".chunk.js";
};